import { ClienteAnaliseMercadoLancamentoClassificacaoCreate } from './classificacao';
import { CLIENTE_ANALISE_MERCADO_PERIODICIDADE_ANUAL } from '../../domain/cliente-analise-mercado-periodicidade.enum';
import { Cliente } from '../../../pessoa/cliente/cliente';
import { Representante } from '../../../pessoa/representante/representante';

export class ClienteAnaliseMercadoLancamentoCreate {
    perspectiva: number;
    idCliente: number;
    cliente: Cliente;
    representante: Representante;
    data: Date;
    ano: number;
    periodicidade: number;
    anotacao: string;
    idGrupoClassificacao: number;
    classificacoesSlug: number[];
    classificacoes: ClienteAnaliseMercadoLancamentoClassificacaoCreate[];

    constructor(perspectiva: number, idCliente: number, ano: number) {
        this.perspectiva = perspectiva;
        this.idCliente = idCliente;
        this.ano = ano;
        this.periodicidade = CLIENTE_ANALISE_MERCADO_PERIODICIDADE_ANUAL.id;
        this.classificacoesSlug = [];
        this.classificacoes = [];
    }
}
